import React, { useState } from 'react'
import '../../../../../containers/Expressway/expressway.scss'
import { apiPostHelper, getTravellerObj } from '../../../../../utils'
import { UPDATE_PRIMARY_TRAVELLER } from '../../../../../constants/api_endpoints'

function PrimaryTravellerDetails(props) {
  const { traveller, setTraveller, originalTraveller } = props
  const [showForm, setShowForm] = useState(false)
  const [detailHover, setDetailHover] = useState(false)
  const [showEmptyNameError, setShowEmptyNameError] = useState(false)
  const [showEmptyMobileError, setShowEmptyMobileError] = useState(false)
  const [showInvalidMobileError, setShowInvalidMobileError] = useState(false)

  const sendUpdateRequest = () => {
    const response = apiPostHelper(
      `${UPDATE_PRIMARY_TRAVELLER}`,
      {
        person: {
          personal_data: {
            title: traveller.title,
            first_name: traveller.fName,
            last_name: traveller.lName
          },
          contact_data: {
            phone_numbers: [
              {
                category: traveller.category,
                contact_data_id: traveller.contact_data_id,
                country_code: traveller.country_code,
                id: traveller.id,
                mobile_number: traveller.mobile_number,
                phone_number_value: traveller.mNo,
                seq_no: traveller.seq_no
              }
            ]
          }
        }
      },
      false,
      {},
      { accept: 'text/json' }
    )
    return response
  }

  const isEmptyTravellerData = () => {
    if (traveller.fName === '' && traveller.lName === '' && traveller.mNo === '') {
      setShowForm(true)
      return true
    }
    return false
  }

  const updateTravellerData = async () => {
    setShowEmptyNameError(false)
    setShowEmptyMobileError(false)
    setShowInvalidMobileError(false)
    let saveFlag = true
    if (traveller.fName === '') {
      setShowEmptyNameError(true)
      saveFlag = false
    }
    if (traveller.mNo === '') {
      setShowEmptyMobileError(true)
      saveFlag = false
    }
    if (traveller.mNo && traveller.mNo.length !== 10) {
      setShowInvalidMobileError(true)
      saveFlag = false
    }

    if (saveFlag) {
      const res = await sendUpdateRequest()
      const travellerObj = getTravellerObj(res)
      setTraveller(travellerObj)
      setShowForm(false)
    }
  }

  const handleMobileNoInput = e => {
    if (Number.isInteger(parseInt(e.target.value, 10)) &&
      Number.isInteger(parseInt(e.target.value, 10))) {
      setTraveller({ ...traveller, mNo: e.target.value })
    }
  }

  const getTravellerForm = () => {
    return (
      <>
        <div className="flex flex-left">
          <div className="pTravellerLabel mt-3 w-150 fs-12"> <div className="flex flex-right">Title</div></div>
          <select className="ml-3 mt-3" onChange={e => setTraveller({ ...traveller, title: e.target.value })} value={traveller.title} id="title" name="title" style={{ border: '1px solid #555', borderRadius: '2px' }}>
            <option value="mr">Mr</option>
            <option value="ms">Ms</option>
            <option value="mrs">Mrs</option>
          </select>
        </div>
        <div className="flex flex-left">
          <div className="pTravellerLabel mt-3 w-150 fs-12"> <div className="flex flex-right"> Traveller name</div></div>
          <input type="text" className="mt-3 ml-3 border-full-black" placeholder="First name" value={traveller.fName} onChange={e => setTraveller({ ...traveller, fName: e.target.value })} />
          <input type="text" className="mt-3 ml-1 border-full-black" placeholder="Last name" value={traveller.lName} onChange={e => setTraveller({ ...traveller, lName: e.target.value })} />
        </div>
        <If condition={showEmptyNameError}>
          <div className="travellerErrorMsg"> You missed this </div>
        </If>
        <div className="flex flex-left">
          <div className="pTravellerLabel mt-3 w-150 fs-12"> <div className="flex flex-right"> Mobile number </div> </div>
          <input type="text" className="border-full-black ml-3 mt-3 w-70" />
          <input type="text" className="ml-1 mt-3 border-full-black" placeholder="Mobile no." value={traveller.mNo} onChange={e => handleMobileNoInput(e)} />
        </div>
        <If condition={showEmptyMobileError}>
          <div className="travellerErrorMsg"> You missed this </div>
        </If>
        <If condition={showInvalidMobileError}>
          <div className="travellerErrorMsg"> Mobile number entered is not valid </div>
        </If>

        <button type="submit" className="pTravellerBtn ml-40 mt-3 cursor-pointer" onClick={() => updateTravellerData()}>Save</button>
        <span className="fs-12"> or
          <span className="pTravellerBtnCancel cursor-pointer" onClick={() => { setShowForm(false); setDetailHover(false); setTraveller({ ...originalTraveller }) }}>cancel </span>
        </span>
      </>
    )
  }

  const getTravellerData = () => {
    return (
      <div className="travellerData cursor-pointer" onClick={() => setShowForm(true)} onMouseEnter={() => setDetailHover(true)} onMouseLeave={() => setDetailHover(false)}>
        <span className="pTravellerLabel ml-11 fs-12">Traveller name</span>
        <span className="pTravellerLabel grey-5  fs-12 ml-1">{traveller.title} {traveller.fName} {traveller.lName}</span>
        <If condition={traveller.mNo}>
          <span className="pTravellerLabel fs-12" style={{ marginLeft: '-12px' }}> ({traveller.mNo}) </span>
        </If>
        <If condition={detailHover}>
          <span className="editTravellerData">edit</span>
        </If>
        <div className="pTravellerLabel fw-300 ml-36">We will prefill above name and phone in your bookings. You can change it here or while booking.</div>
      </div>
    )
  }

  return (
    <div>
      {showForm || isEmptyTravellerData() ? getTravellerForm() : getTravellerData()}
    </div>
  )
}

export default PrimaryTravellerDetails
